<template>
  <div class="footer">
 
  <reg-flotingbtn ></reg-flotingbtn>
  <whatapp-chat ></whatapp-chat>
   
    <b-container class="footer-top bv-example-row d-none d-md-block" fluid  >
            <b-row style="color: #ffff;">
                <b-col  class="marginBot" cols="6" lg="2" md="6"  sm="6">
                    <div class="footer-title">
                        <h4>Top Categories</h4>
                    </div>
                    <div class="footer-content">
                        <ul class="footerLinkul">
                            <li><b-link href="/women" >Women's Fashion</b-link></li>
                            <li><b-link href="/men">Men's Fashion</b-link></li>
                            <li><b-link href="/cosmetics/makeup">Makeup</b-link></li>
                            <li><b-link href="/cosmetics/skin-care">Skin Care</b-link></li>                          
                            <li><b-link href="/home-essentials/arts-and-crafts" >Arts and Crafts</b-link></li>                           
                        </ul>
                    </div>
                </b-col>
                <b-col class="marginBot" cols="6" lg="2"  md="6" sm="6">
                    <div class="footer-title">
                        <h4>Learn about Us</h4>
                    </div>
                    <div class="footer-content">
                        <ul class="footerLinkul">
                            <li><b-link href="/about">About us</b-link></li>
                            <li><b-link href="/careers">Careers</b-link></li>
                            <li><b-link href="#">Media</b-link></li>
							<li><b-link href="/contactus">Contact us</b-link></li>
							<li><b-link href="/videos">Watch & Buy</b-link></li>
                        </ul>
                    </div>
                </b-col>
                <b-col class="marginBot" cols="6" lg="2" md="6"  sm="6">
                    <div class="footer-title">
                        <h4>Earn With Us</h4>
                    </div>
                    <div class="footer-content">
                        <ul class="footerLinkul">
                            <li><b-link href="/marketing/seller">Sell on Alluraa</b-link></li>
                            <li><b-link :href="'/marketing/'+$root.INFLUENCER">Become an {{$root.INFLUENCER_TEXT}}</b-link></li>
                            <li><b-link href="/marketings">Advertise on Alluraa</b-link></li>
                            <!--<li><b-link href="/faq">FAQs</b-link></li>-->
                            <li><b-link href="/offers">Explore Offers</b-link></li>
							 <li><b-link href="/training">Training Registration</b-link></li>
                        </ul>
                    </div>
                </b-col>
                <b-col class="marginBot" cols="6" lg="2" md="6"  sm="6">
                    <div class="footer-title">
                        <h4>Policies</h4>
                    </div>
                    <div class="footer-content">
                        <ul class="footerLinkul">
                            <li><b-link href="/privacy-policy">Privacy</b-link></li>
                            <li><b-link href="/return-policy">Return</b-link></li>
                            <li><b-link href="/shipping-policy">Shipping</b-link></li>
                            <li><b-link href="/t&c">Terms of Use</b-link></li>  
							<!--<li><b-link href="#">Blogs</b-link></li> -->
							<li><b-link href="/faq">FAQs</b-link></li>
                        </ul>
                    </div>
                </b-col>
               
                <b-col class="marginBot" cols="12"  lg="4" md="6" sm="12"  >
                    <b-container class=" d-none d-md-block">
						<div class="footer-title">
							<h4>Contact Us</h4>
						</div>
						<div class="footer-content">                        
							<ul class="footerLinkul">
								<li>Appack Technologies LLP <br />House No. 163, 1st Floor,<br />Block – CB, Ring Road, Naraina,<br />New Delhi – 110028</li>
															
							</ul>
						</div>
						<b-row>
							<b-col cols="1"><b-link href="mailto:contactus@alluraa.com">contactus@alluraa.com</b-link></b-col>
							
						</b-row>
						
					</b-container>
					<b-container class="border-left d-md-none pl-0">
						<div class="footer-title">
							<h4>Contact Us</h4>
						</div>
						<div class="footer-content">                        
							<ul class="footerLinkul">
								<li><strong>Regd. Off.</strong>House No. 163, 1st Floor, Block – CB, Ring Road, Naraina, New Delhi – 110028</li>
															
							</ul>
						</div>
						<b-row>
							<b-col cols="1"><b-link href="mailto:contactus@alluraa.com">contactus@alluraa.com</b-link></b-col>
							
						</b-row>
						
							
						
					</b-container>
                </b-col>
            </b-row>
           
            </b-container>
			<b-row class="m-0 pt-2 d-sm-block d-md-none">
				<b-col  class=" p-0">
					<footermobile-swiper></footermobile-swiper>
				</b-col>	
					
			</b-row>
			<div class="shippingSec">
				<b-container>
					<b-row class="m-0 " >
								
						<b-col lg="4" md="12"  sm="12"><div class="shippingSecd1"><b-img class="shippingSecImg" src="../assets/home/Shipping.png" alt="Free Shipping"></b-img> </div><div class="shippingSecd2 spl-6" >Free Shipping <br />Order over {{$root.currency()}}499/-</div></b-col>
						
						<b-col  lg="5" md="12"  sm="12" class="marSh"><div class="shippingSecd1 shippingSecdM "><b-img class="shippingSecImg" src="../assets/home/Customer-Support.png" alt="Customer Support"></b-img> </div><div class="shippingSecd2" >Customer Support <br />Before & After Purchase</div></b-col>
					
						<b-col   lg="3" md="12"  sm="12"><div class="shippingSecd1"><b-img class="shippingSecImg" src="../assets/home/Cash-on-Delivery.png"></b-img> </div><div class="shippingSecd2" >Cash on Delivery <br />Available</div></b-col>
								
					</b-row>
				</b-container>
			</div>
			<b-container class="pt-4">
			<b-row class="m-0 pr-3">
					<b-col lg="6" sm="12" class=" p-0 text-center paymetIcon">
						<b-img src="../assets/home/paymet.png" class="ml-3" alt="payme"></b-img>
					</b-col>
					<b-col lg="6" sm="12" class="text-center siconM">
							<ul class="socialFooter">
							<li><a href="https://www.facebook.com/AlluraaTech" target="_blank" class="facebook"><i class="fa fa-facebook"></i></a></li>
							<li><a href="https://twitter.com/AlluraaTech" target="_blank" class="twitter"><i class="fa fa-twitter"></i></a></li>
							<li><a href="https://www.youtube.com/channel/UCSQjbB7kmloX7R74KK1w1SQ" target="_blank" class="youtube"><i class="fa fa-youtube"></i></a></li>
							<li><a href="https://www.linkedin.com/company/alluraa/" target="_blank" class="linkedin"><i class="fa fa-linkedin"></i></a></li> 
							<li><a href="https://www.instagram.com/alluraaTech" target="_blank" class="instagram"><i class="fa fa-instagram"></i></a></li>
							<li><a href="https://web.whatsapp.com/send?text=&phone=918920670756" target="_blank" class="Whatsapp"><i class="fa fa-whatsapp"></i></a></li> 
							</ul>
							
					</b-col>
			</b-row>
			
			</b-container>
		
			 <!-- <b-row class="pb-3 pt-3 m-0">
                <b-col class=" p-0 text-center paymetIcon">
					<h6>PAYMENT</h6>
					<b-img src="../assets/home/paymet.png"></b-img>
				
				</b-col>
            </b-row> -->
			
			<!--  ================ mobile View Footer =================== -->
			
			
			
			<!-- ================================ -->
		
            <b-container fluid class="footer-bottom text-center">
            <!-- p>For daily updates, Find us on:</p>
            <b-row class="social">
                <b-col cols="2" xs="2" sm="1" md="1" offset="2" offset-sm="4" offset-md="4" class="social-link"><b-link href="https://www.instagram.com/alluraaTech" target="_blank"><img src="../assets/Instagram.png"></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://twitter.com/AlluraaTech" target="_blank"><b-img src="../assets/twitter.png"></b-img></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://www.linkedin.com/company/alluraa/" target="_blank"><b-img src="../assets/Linkedin.png"></b-img></b-link></b-col>
                <b-col cols="2" xs="2" sm="1" md="1" class="social-link"><b-link href="https://www.facebook.com/AlluraaTech" target="_blank"><b-img src="../assets/facebook.png"></b-img></b-link></b-col>
            </b-row>-->
			<b-row class="m-0 pt-2 d-sm-block d-md-none">
					<b-col  class=" p-0">
						<ul class="list-group list-group-horizontal footerList">
							<li class="ppb"><b-link href="/privacy-policy" class="mpp">Privacy</b-link> </li>
							<li class="ppb"><b-link href="/return-policy" class="mpp">Return</b-link> </li>
							<li class="ppb"><b-link href="/shipping-policy" class="mpp">Shipping</b-link></li>
							<li class="ppb" style="width: 96px;"><b-link href="/t&c" class="mpp">Terms of Use</b-link></li>
							<li ><b-link href="/faq" class="mpp">FAQs</b-link></li>
						
						</ul>
						
						
						<!--<ul class="list-group list-group-horizontal">
						  <li class="list-group-item">Cras justo odio</li>
						  <li class="list-group-item">Dapibus ac facilisis in</li>
						  <li class="list-group-item">Morbi leo risus</li>
						  <li class="list-group-item">Morbi leo risus</li>
						</ul> -->
					
					</b-col>
					
					
			</b-row>
			
            <b-row >
                <b-col>
                <p class="p-0 font-md m-0" style="">© {{ new Date() | moment("YYYY") }} APPACK TECHNOLOGIES LLP</p>
                </b-col>
            </b-row>
        </b-container>
  </div>
  
</template>

<script>
import regFloting from "@/components/reg-floting.vue";
import whatappChat from "@/components/whatapp-chat.vue";
import footermobileSwiper from "@/components/footermobile-swiper.vue";
export default {
  name: 'HelloWorld',
  components: {
    "reg-flotingbtn": regFloting,
    "whatapp-chat": whatappChat,
    "footermobile-swiper": footermobileSwiper,
	},
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
    }
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /*  .footer .footer-top{
     max-width: 90% !important;     
    margin-left: 10% !important;
    }
    .footerLinkul{
     padding: 0px !important;
    }
.footerLinkul li {
    display: block;
    margin: 0 0px !important;
    line-height: 24px;
    font-size: 0.9rem !important;
    text-align: left;
}*/

	.mpp{
		color: #ffffff !important;
		font-size: 13px;
	}
	.ppb{
		  border-right: 1px solid #c6c6c6;
	}
	
	.footerList li{ 
		padding: 0 5px 0 10px;
	}
	
	


</style>
